// @index('./*.ts', pp => `import { ${pp.name} } from '${pp.path}';`)
import { AliasTransform } from './AliasTransform';
import { BaseTransform } from './BaseTransform';
import { CaseTransform } from './CaseTransform';
import { CollectionTransform } from './CollectionTransform';
import { ConditionalTransform } from './ConditionalTransform';
import { FilterTransform } from './FilterTransform';
import { FormatTransform } from './FormatTransform';
import { GroupTransform } from './GroupTransform';
import { MapTransform } from './MapTransform';
import { NumberTransform } from './NumberTransform';
import { ObjectTransform } from './ObjectTransform';
import { PivotTransform } from './PivotTransform';
import { QueryTransform } from './QueryTransform';
import { RegexTransform } from './RegexTransform';
import { RenameFieldTransform } from './RenameFieldTransform';
import { ReplaceTransform } from './ReplaceTransform';
import { SplitTransform } from './SplitTransform';
import { SwitchTransform } from './SwitchTransform';
import { Transform } from './Transform';
import { TrimTransform } from './TrimTransform';
import { VisibleTransform } from './VisibleTransform';
// @endindex
// @index('./*', pp => `import * as ${pp.name} from '${pp.path}';`, { "ignore": ["./*.ts", "./*.md"] })

// @endindex
export {
	// @index('./*', pp => `${pp.name},`, { "ignore": ["./*.md"] })
	AliasTransform,
	BaseTransform,
	CaseTransform,
	CollectionTransform,
	ConditionalTransform,
	FilterTransform,
	FormatTransform,
	GroupTransform,
	MapTransform,
	NumberTransform,
	ObjectTransform,
	PivotTransform,
	QueryTransform,
	RegexTransform,
	RenameFieldTransform,
	ReplaceTransform,
	SplitTransform,
	SwitchTransform,
	Transform,
	TrimTransform,
	VisibleTransform,
	// @endindex
};